import type {UpdateResourceStatusSchema} from '@cypro/engine/mutators'
import {useUpdateSolutionDrugStatus} from '@/modules/drug-catalog/solutions/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {LuFlaskConical} from 'react-icons/lu'

export function SolutionSummary() {
  const {solutionDrug} = useSolutionDrugContext()
  const updateStatus = useUpdateSolutionDrugStatus()
  const canManageCatalogue = useCan('catalogue.manage')

  return (
    <ResourceDrawerSummary
      title={solutionDrug.name}
      description={solutionDrug.code}
      icon={LuFlaskConical}
      status={solutionDrug.status}
      {...(canManageCatalogue
        ? {
            onChangeStatus: (status: UpdateResourceStatusSchema['status']) =>
              updateStatus({id: solutionDrug.id, status}),
          }
        : {})}
    />
  )
}
